<h2 mat-dialog-title>Create Document</h2>
<mat-dialog-content class="mat-typography">
<app-form-wizard></app-form-wizard>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>